import { render, staticRenderFns } from "./customSelfCharge.vue?vue&type=template&id=be8c76a0&scoped=true"
import script from "./customSelfCharge.vue?vue&type=script&lang=ts"
export * from "./customSelfCharge.vue?vue&type=script&lang=ts"
import style0 from "./customSelfCharge.vue?vue&type=style&index=0&id=be8c76a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8c76a0",
  null
  
)

export default component.exports